module.exports = __webpack_public_path__ + "static/c1-c27d54b2989544878106f206e23c095e.svg";